import styled from '@emotion/styled';

const GroupSelectorButtonLabel = styled('div')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export default GroupSelectorButtonLabel;
